import React, { useState, useEffect } from "react";
import includes from "lodash/includes";
import CKEditor from "@ckeditor/ckeditor5-react";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { storage } from "firebase";
import { getFilterList } from "../Database/firebase";
import { v4 as uuidv4 } from "uuid";
import {
  Form,
  Input,
  Button,
  Upload,
  Typography,
  Spin,
  DatePicker,
  Select,
  Checkbox,
  Radio,
  Switch,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import { isEmpty, filter, map } from "lodash";

const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;
const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
};

const buttonItemLayout = {
  wrapperCol: {
    span: 14,
    offset: 4,
  },
};

const DeckForm = ({
  onSubmit,
  onCancelEditMode,
  onFileUpload,
  onChange,
  file,
  videoFile,
  featuredId,
  title,
  applyedFilters,
  breakingNews,
  featured,
  none,
  description,
  description_editor,
  affiliateLink,
  releaseNewsPrice,
  releaseDetailwhere,
  releaseDetailWhen,
  releaseDetailPrice,
  date,
  timer,
  decks,
  zone,
  tags,
  loading,
  id,
  editMode,
  onDeletePress,
  onVedioUpload,
  setIsShowCommentSection,
  isShowCommentSection,
  isNewSliderArticle,
  setisNewSliderArticle,
  isBreakingNews,
  setisBreakingNews,
  webViewCommentLink
}) => {
  const [filterList, setFilterList] = useState([]);
  const [shouldUploadImage, setShouldUploadImage] = useState(true);
  const [shouldUploadVideo, setShouldUploadVideo] = useState(false);
  
  decks = decks.sort((a, b) => b.date - a.date);

  console.log("print console data", featuredId, decks);
  useEffect(() => {
    getFilterList.then((doc) => {
      setFilterList(doc.data().Filters);
    });
  }, []);
  //   useEffect(() => {
  //     const handleProps = () => {
  //       if (editMode) {
  //         seteditorState(EditorState.createWithContent(
  //           ContentState.createFromBlockArray(
  //             convertFromHTML(description_editor)
  //           )
  //         ),)
  //       }
  //      };
  //     handleProps();
  //     return () => {
  //         handleProps();
  //     }

  // }, [editMode]);

  // const [editorState ,seteditorState]= useState(
  //  EditorState.createWithContent(
  //     ContentState.createFromBlockArray(
  //       convertFromHTML(editMode?description_editor:``)
  //     )
  //   ),);

  const handleFileUploadType = (event) => {
    const { value } = event.target;
    setShouldUploadImage(value === "image");
    setShouldUploadVideo(value !== "image");
  };

  const onEditorStateChange = (editorState) => {
    console.log("HTML View", editorState.getCurrentContent());
    // seteditorState(editorState)
    // console.log("================", convertToRaw(editorState.getCurrentContent()))
    // var val = draftToHtml(convertToRaw(editorState.getCurrentContent()))
    // console.log("val>>", val);
    onChange(editorState, "description_editor");
  };

  const uploadImageCallBack = (file) => {
    return new Promise((resolve, reject) => {
      var uploadTask = storage().ref(`/editor_images/${new Date()}`).put(file);

      uploadTask.on(
        "state_changed",
        function (snapshot) {
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case storage.TaskState.PAUSED: // or 'paused'
              console.log("Upload is paused");
              break;
            case storage.TaskState.RUNNING: // or 'running'
              console.log("Upload is running");
              break;
          }
        },
        function (error) {
          reject(error);
        },
        function () {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            const descriptionImagesUrl = JSON.parse(
              localStorage.getItem("descriptionImagesUrl")
            );
            if (!isEmpty(descriptionImagesUrl)) {
              descriptionImagesUrl.push(downloadURL);
              localStorage.setItem(
                "descriptionImagesUrl",
                JSON.stringify(descriptionImagesUrl)
              );
            } else {
              localStorage.setItem(
                "descriptionImagesUrl",
                JSON.stringify([downloadURL])
              );
            }

            console.log("File available at", downloadURL);
            resolve({ data: { link: downloadURL } });
          });
        }
      );
    });
  };
  const doCollapseCall = () => {
    alert("run");
  };

  const toolbar = {
    fontFamily: {
      options: [
        "Arial",
        "Georgia",
        "Impact",
        "Tahoma",
        "Times New Roman",
        "Verdana",
        "Open Sans",
      ],
    },
    inline: {
      inDropdown: false,
    },
    list: { inDropdown: true },
    textAlign: { inDropdown: true },
    link: { inDropdown: true },
    history: { inDropdown: true },
    emoji: { inDropdown: false },
    image: {
      uploadCallback: uploadImageCallBack,
      previewImage: true,
      alt: { present: true, mandatory: false },
      inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
    },
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Form {...formItemLayout}>
          <Title level={3} style={{ marginLeft: "10%" }}>
            {editMode ? "Update" : "Add"} Article
          </Title>
          <Form.Item label="Title">
            <Input
              onChange={({ target }) => onChange(target.value, "title")}
              value={title}
              placeholder="Enter Article Title"
            />
          </Form.Item>
          <Form.Item label="Description">
            <Editor
              //  defaultEditorState={editorState}
              editorState={description_editor}
              editorClassName="editorClassName"
              toolbarClassName="toolbar-class"
              wrapperClassName="wrapperClassName"
              wrapperStyle={{
                minHeight: 500,
              }}
              editorStyle={{
                minHeight: 376,
                border: "1px solid #F1F1F1",
                padding: 5,
                borderRadius: 2,
                height: "auto",
              }}
              toolbar={toolbar}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          <Form.Item label="Tags-comma separate">
            <Input
              onChange={({ target }) => onChange(target.value, "tags")}
              value={tags && tags.toString()}
              placeholder="tag1,tag2,tag3"
            />
          </Form.Item>
          <Form.Item label="Date">
            <DatePicker
              onChange={(date) => onChange(date.toDate().getTime(), "date")}
              value={date && moment(date)}
            />
          </Form.Item>
          <Form.Item label="Timer Date">
            <DatePicker
              onChange={(date) =>
                onChange(date && date.toDate().getTime(), "timer")
              }
              value={timer && moment(timer)}
              showTime={{ format: "HH:mm:ss" }}
            />
          </Form.Item>
          <Form.Item label="Time Zone">
            <Select
              onChange={(e) => {
                onChange(e, "zone");
              }}
              value={zone}
            >
              <Option value="America/New_York">EST</Option>
              <Option value="America/Los_Angeles">PST</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Affiliate Link">
            <Input
              onChange={({ target }) => onChange(target.value, "affiliate")}
              value={affiliateLink}
              placeholder="Enter Affiliate Link"
            />
          </Form.Item>
          <Form.Item label="Releases Price">
            <Input
              onChange={({ target }) => onChange(target.value, "priceVal")}
              value={releaseNewsPrice}
              placeholder="Enter price"
            />
          </Form.Item>
          <Form.Item label="Releases Detail When">
            <Input
              onChange={({ target }) => onChange(target.value, "detailWhenVal")}
              value={releaseDetailWhen}
              placeholder="Enter When"
            />
          </Form.Item>
          <Form.Item label="Releases Detail Where">
            <Input
              onChange={({ target }) => onChange(target.value, "detailWhereVal")}
              value={releaseDetailwhere}
              placeholder="Enter Where"
            />
          </Form.Item>
          <Form.Item label="Releases Detail Price">
            <Input
              onChange={({ target }) => onChange(target.value, "detailPriceVal")}
              value={releaseDetailPrice}
              placeholder="Enter Detail Price"
            />
          </Form.Item>
          <Form.Item label="Filters">
            <Checkbox.Group
              options={filterList}
              onChange={(value) => onChange(value, "applyedFilters")}
              value={applyedFilters}
            />
          </Form.Item>

          <Form.Item label="Is featured">
            {(featuredId.length < 2 ) || editMode ? (
              editMode && includes(featuredId, id) ? (
                <Radio
                  onChange={(value) => {
                    console.log("EditFeavalue", value);
                    onChange(false, "breakingNews");
                    onChange(false, "none");
                    onChange(!featured, "featured");
                  }}
                  checked={featured}
                />
              ) :  (
                 <Radio
                onChange={(value) => {
                  onChange(false, "breakingNews");
                  onChange(false, "none");
                  onChange(!featured, "featured");
                }}
                checked={featured}
              />
              )
            ) : (
              // <Title level={4} style={{ color: "#c04849", marginLeft: "3%" }}>
              //   Already created!
              // </Title>
              // <Radio
              //   onChange={(value) => {
              //     onChange(false, "breakingNews");
              //     onChange(false, "none");
              //     onChange(!featured, "featured");
              //   }}
              //   checked={featured}
              // />
              <Radio defaultChecked disabled={true}>
                Already created!
              </Radio>
            )}
          </Form.Item>

          {/* <Form.Item label="Is this Breaking news">
            {decks.find((item) => featuredId == item.id) ? (
              editMode && featuredId == id ? (
                <Radio
                  onChange={(value) => {
                    console.log("Editvalue", value);
                    onChange(false, "featured");
                    onChange(false, "none");
                    onChange(!breakingNews, "breakingNews");
                  }}
                  checked={breakingNews}
                />
              ) : (
                <Radio defaultChecked disabled={true}>
                  Already created!
                </Radio>
              )
            ) : (
              // <Title level={4} style={{ color: "#c04849", marginLeft: "3%" }}>
              //   Already created!
              // </Title>
              <Radio
                onChange={(value) => {
                  console.log("value", value);
                  onChange(false, "featured");
                  onChange(false, "none");
                  onChange(!breakingNews, "breakingNews");
                }}
                checked={breakingNews}
              />
            )}
          </Form.Item> */}

          <Form.Item label="None">
            <Radio
              onChange={(value) => {
                onChange(false, "featured");
                onChange(false, "breakingNews");
                onChange(true, "none");
              }}
              checked={none}
            />
          </Form.Item>

          <Form.Item label="Show Comment Section">
            <Switch
              checked={isShowCommentSection}
              onChange={(value) => setIsShowCommentSection(value)}
            />
          </Form.Item>

          {
            isShowCommentSection && (
              <Form.Item label="Web View Comment Link">
                <Input
                  onChange={({ target }) => onChange(target.value, "webViewCommentLink")}
                  value={webViewCommentLink}
                  placeholder="Enter WebView Comment Link"
                />
              </Form.Item>
          )}

          <Form.Item label="Add to Latest Slider">
            <Switch
              checked={isNewSliderArticle}
              onChange={(value) => setisNewSliderArticle(value)}
            />
          </Form.Item> 

          <Form.Item label="Is Breaking News">
            <Switch
              checked={isBreakingNews}
              onChange={(value) => setisBreakingNews(value)}
            />
          </Form.Item>  

          <Form.Item label="Upload File Type :">
            <Radio.Group
              name="filegroup"
              defaultValue="image"
              onChange={handleFileUploadType}
            >
              <Radio value="image" name="image">
                Image
              </Radio>
              <Radio value="video" name="video">
                Video
              </Radio>
            </Radio.Group>
          </Form.Item>

          {shouldUploadImage && (
            <Form.Item
              name="upload"
              label="Article Image"
              valuePropName="fileList"
              getValueFromEvent={onFileUpload}
            >
              <Upload
                accept="image/gif, image/jpeg, image/png"
                multiple={false}
                type="select"
                name="thumbnail"
                showUploadList={false}
              >
                <Button>
                  <UploadOutlined /> Click to upload
                </Button>
                {file && <p>{file.name}</p>}
              </Upload>
            </Form.Item>
          )}
          {shouldUploadVideo && (
            <Form.Item
              name="upload"
              label="Article Video"
              valuePropName="fileList"
              getValueFromEvent={onVedioUpload}
            >
              <Upload
                accept="video/mp4,video/x-m4v,video/*,video/m3u8"
                multiple={false}
                type="select"
                name="video"
                showUploadList={false}
              >
                <Button>
                  <UploadOutlined /> Click to upload
                </Button>
                {videoFile && <p>{videoFile.name}</p>}
              </Upload>
            </Form.Item>
          )}

          <Form.Item {...buttonItemLayout}>
            {!editMode ? (
              <Button
                onClick={onSubmit}
                type="primary"
                style={{
                  background: "#ff0b53",
                  borderColor: "#ff0b53",
                  borderRadius: 5,
                }}
              >
                Submit
              </Button>
            ) : (
              <Button
                onClick={onSubmit}
                type="primary"
                style={{
                  background: "#ff0b53",
                  borderColor: "#ff0b53",
                  borderRadius: 5,
                }}
              >
                Update
              </Button>
            )}
            {editMode && (
              <Button
                style={{ marginLeft: 20 }}
                onClick={onCancelEditMode}
                type="ghost"
              >
                Cancel
              </Button>
            )}
            {editMode && (
              <Button
                style={{ marginLeft: 20 }}
                onClick={onDeletePress}
                type="danger"
              >
                Delete
              </Button>
            )}
            {/* </Spin> */}
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};

export default DeckForm;
